import { useState } from "react";

const PDFViewerModal = ({ title, pdfUrl, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Trigger */}
      <div onClick={() => setOpen(true)} className="inline-block cursor-pointer">
        {children}
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-5xl h-[80vh] relative shadow-xl">
            
            {/* Header */}
            <div className="flex justify-between items-center border-b px-4 py-3">
              <h3 className="font-heading text-lg">{title}</h3>
              <button
                onClick={() => setOpen(false)}
                className="text-black hover:text-red-500 text-xl"
              >
                ✕
              </button>
            </div>

            {/* PDF */}
            <iframe
              src={pdfUrl}
              title={title}
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PDFViewerModal;